export default __webpack_public_path__ + "static/media/Boo.39b88e87.png";